import { LitElement, css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import { resolveRouterPath } from '../router';

import '@shoelace-style/shoelace/dist/components/button/button.js';
@customElement('app-header')
export class AppHeader extends LitElement {
  @property({ type: String }) title = 'Simple Price Menu';
  @property({ type: String, attribute: 'icon-name' }) iconName = 'circle-half';
  @property({ type: String }) target = '/';

  static styles = css`
    header {
      background: var(--sl-color-neutral-300);
      color: var(--sl-color-neutral-800);
      padding: 13px;

      position: fixed;
      left: env(titlebar-area-x, 0);
      top: env(titlebar-area-y, 0);
      height: env(titlebar-area-height, 30px);
      width: env(titlebar-area-width, 100%);
      -webkit-app-region: drag;
      z-index: var(--sl-z-index-drawer);
    }

    header h1 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: var(--sl-font-size-large);
    }

    #header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      left: env(titlebar-area-x, 0);
      top: env(titlebar-area-y, 0);
      height: env(titlebar-area-height, 30px);
      width: env(titlebar-area-width, 95%);
    }

    .header-icon {
      font-size: var(--sl-font-size-x-large);
    }
  `;

  render() {
    return html`
      <header>
        <div id="header-content">
          <h1>${this.title}</h1>
          <sl-icon-button
            class="header-icon"
            name="${this.iconName}"
            label="Navigation"
            href="${resolveRouterPath(this.target)}"
          ></sl-icon-button>
        </div>
      </header>
    `;
  }
}
